export const FormProp = Object.freeze({
    Fields: 'fields',
});